import React from "react";

function Preloader() {
  return(
  <div data-w-id="4e9b344c-84aa-70a5-c2a2-b548627f600a" className="preloader">
  <div data-w-id="4e9b344c-84aa-70a5-c2a2-b548627f600b" data-animation-type="lottie" data-src="documents/preloader.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="2" data-duration="0"></div>
  </div>
  );
}
export default Preloader;
